import React from 'react';
import { connect } from 'react-redux';
import { findWithUUID } from '@/utils/uuidHelper';
import LookupInformationHeader from '../components/LookupInformationHeader';
import LookupVocabularyTable from '../components/LookupVocabularyTable';
import DictionaryLookupSettings from './DictionaryLookupSettings';
import { canEditDataset } from '../../helper';

const DictionaryLookupsInformation = ({
  category,
  code,
  lookups,
  lookupName,
  canEdit,
  count,
  saveErrors,
  validationWarnings,
}) => (
  <>
    <LookupInformationHeader
      category={category}
      code={code}
      canEdit={canEdit}
      errors={saveErrors}
      count={count}
    />
    {count > 0 && (
    <>
      <DictionaryLookupSettings />
      <LookupVocabularyTable
        className="lookup"
        lookupItems={lookups[lookupName]}
        canEdit={canEdit}
        lookupName={lookupName}
        errors={saveErrors}
        validationWarnings={validationWarnings}
      />
    </>
    )}
  </>
);

const mapStateToProps = ({
  datasets: {
    lookups,
  },
  auth: {
    role,
  },
}) => {
  const dictionary = findWithUUID(lookups.dictionaries, lookups.activeDictionaryUUID);
  const items = dictionary ? dictionary.lookups || {} : {};

  return (
    {
      canEdit: canEditDataset(lookups, role),
      category: lookups.category,
      code: lookups.code,
      count: Object.keys(items).length,
      lookupName: lookups.activeLookupName,
      lookups: items,
      saveErrors: lookups.saveErrors,
      validationWarnings: lookups.validationWarnings,
    }
  );
};

export default connect(mapStateToProps)(DictionaryLookupsInformation);
